import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import state from './state'

const moduleLinks = {
  namespaced: true,
  actions,
  state,
  getters,
  mutations
}

export default moduleLinks
